import { Flex, Radio } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H3 } from "src/atoms/typography";
import { Subtitle } from "src/atoms/typography";

const themeOptions = [
  {
    id: "dark",
    stringKey: "theme.option.dark"
  },
  {
    id: "light",
    stringKey: "theme.option.light"
  },
  {
    id: "system",
    stringKey: "theme.option.default"
  }
];

function ThemeOption({ selectedTheme, t, onChange, id, stringKey }) {
  return (
    <Flex
      as="label"
      mb="8px"
      alignItems="center"
      sx={{
        "&:last-of-type": {
          mb: "0px"
        }
      }}
    >
      <Radio
        value={id}
        isChecked={selectedTheme === id}
        onChange={(e) => onChange(e.target.value)}
      />
      <Subtitle ml="15px" color="highEmphasis">
        {t(stringKey)}
      </Subtitle>
    </Flex>
  );
}

export default function ThemeSelector({ onChange, selectedTheme }) {
  const { t } = useTranslation();
  return (
    <>
      <Flex flexDirection="column">
        <H3 color="highEmphasis" mb="22px">
          {t("theme.heading")}
        </H3>
        {themeOptions.map((option) => {
          return (
            <ThemeOption
              {...option}
              key={option.id}
              onChange={onChange}
              selectedTheme={selectedTheme}
              t={t}
            />
          );
        })}
      </Flex>
    </>
  );
}
